<template>
  <Navbar />
  <div class="content-wrapper">
    <div class="main-content mt-80">
      <section class="pt-50 pb-60 lg:pt-30 overflow-hidden">
        <div class="container pt-10">
          <div class="row">
            <div class="col-lg-8 mb-30" data-aos="fade-up" :data-aos-delay="200">
              <BlogsContent />
            </div>

            <div class="col-lg-4" data-aos="fade-up" :data-aos-delay="250">
              <Sidebar />
            </div>
          </div>
        </div>
      </section>
    </div>

    <FooterItem />
  </div>
</template>

<script>
import AOS from "aos";
import Navbar from "@/components/Layout/Navbar.vue";
import BlogsContent from "@/components/Blogs/BlogsContent.vue";
import FooterItem from "@/components/Layout/FooterItem.vue";
import Sidebar from "@/components/Blogs/Sidebar.vue";
import { useHead } from "@vueuse/head";
import { mapGetters } from "vuex";
import store from "@/store";

export default {
  components: {
    Navbar,
    BlogsContent,
    FooterItem,
    Sidebar,
  },

  computed: {
    ...mapGetters(["currentLanguage"]),
  },
  methods: {
    //recent courses
    async getRecentCourse() {
      try {
        const response = await getLatestCourses();
        this.latestCourses = response.data;
      } catch (error) {
        console.log(error.message)
      }
    },
    updateHeadMeta() {
      const title =
        this.currentLanguage === "ar"
          ? "المدونة - Planning Force | مقالات ونصائح للتعلم الإلكتروني"
          : "Blogs - Planning Force | Articles and Tips for e-Learning";

      const description =
        this.currentLanguage === "ar"
          ? "استكشف أحدث المقالات والنصائح حول التعلم الإلكتروني، تطوير المهارات، والنمو الشخصي على منصة Planning Force."
          : "Explore the latest articles and tips on e-learning, skill development, and personal growth on the Planning Force platform.";

      const keywords =
        this.currentLanguage === "ar"
          ? "مدونة, Planning Force, مقالات, نصائح, تعلم إلكتروني, تطوير المهارات"
          : "blog, Planning Force, articles, tips, e-learning, skill development";

      useHead({
        title: title,
        meta: [
          { name: "description", content: description },
          { name: "keywords", content: keywords },
          { name: "robots", content: "index, follow" },
          {
            name: "author",
            content:
              this.currentLanguage === "ar"
                ? "معهد Planning Force العالي للتدريب"
                : "Planning Force High Institute for Training",
          },
          {
            name: "language",
            content: this.currentLanguage === "ar" ? "ar" : "en",
          },

          // Open Graph meta tags
          { property: "og:title", content: title },
          { property: "og:description", content: description },
          {
            property: "og:image",
            content: "https://example.com/blog-og-image.jpg",
          }, // Replace with your blogs page image URL
          { property: "og:url", content: "https://example.com/blogs" }, // Replace with your blogs page URL
          { property: "og:type", content: "website" },

          // Twitter Card meta tags
          { name: "twitter:card", content: "summary_large_image" },
          { name: "twitter:title", content: title },
          { name: "twitter:description", content: description },
          {
            name: "twitter:image",
            content: "https://example.com/blog-twitter-image.jpg",
          }, // Replace with your blogs page image URL
        ],
      });
    },
  },
  mounted() {
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  },
  watch: {
    currentLanguage: {
      handler(newLang, oldLang) {
        this.updateHeadMeta();
        store.dispatch("categoriesList");
        this.getRecentCourse()
      },
      immediate: true, // Run the handler immediately when the component is mounted
    },
  },
};
</script>
